const initialState = {
  status: "invalid",
  filters: {
    open: true,
    query: {},
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "USERS_TOGGLE_FILTERS":
      return {
        ...state,
        filters: { ...state.filters, open: !state.filters.open },
      };
    case "USERS_SET_FILTERS_QUERY":
      return {
        ...state,
        filters: { ...state.filters, query: action.query },
      };
    case "USERS_SEARCHING":
      return {
        ...state,
        status: "searching",
      };
    case "USERS_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "USERS_SUCCESS":
      return {
        ...state,
        status: "success",
        ...action,
      };
    case "USERS_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
